import { useSelector } from 'react-redux';

interface ResponsiveTheme {
  responsive: boolean;
  fromTheme: boolean;
}

export const useResponsiveTheme = (): ResponsiveTheme => {
  const theme = useSelector((state: any) => state.ui.theme);

  let responsive: boolean;
  let fromTheme: boolean;

  if (typeof theme.responsive === 'boolean') {
    responsive = theme.responsive;
    fromTheme = true;
  } else {
    responsive = true;
    fromTheme = false;
  }

  return {
    responsive,
    fromTheme,
  };
};
